import useTakeSnapshot from 'pages/Editor/sections/Flow/hooks/useTakeSnapshot';
import { useEffect, useRef, useState } from 'react';

import { useReactFlow } from 'reactflow';

interface UseGroupNameParams {
  id: string;
  initName: string;
}

const useGroupName = ({ id, initName }: UseGroupNameParams) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [name, setName] = useState(initName);
  const [isEditMode, setIsEditMode] = useState(false);

  const { setNodes } = useReactFlow();

  const { takeSnapshot } = useTakeSnapshot();

  const handleNameChange = (event: React.FormEvent<HTMLInputElement>) => {
    const {
      currentTarget: { value },
    } = event;

    setName(value);
  };

  const handleNameDoubleClick = () => {
    setIsEditMode(true);
  };

  const handleSaveName = () => {
    takeSnapshot();
    setNodes((prev) =>
      prev.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              name,
            },
          };
        }

        return node;
      })
    );
    setIsEditMode(false);
  };

  const handleEnterPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') handleSaveName();
  };

  useEffect(() => {
    if (inputRef.current && isEditMode) {
      inputRef.current.focus();
    }
  }, [inputRef, isEditMode]);

  return {
    inputRef,
    name,
    isEditMode,
    onNameChange: handleNameChange,
    onNameDoubleClick: handleNameDoubleClick,
    onSaveName: handleSaveName,
    onEnterPress: handleEnterPress,
  };
};

export default useGroupName;
